// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".messages[data-v-91e50390] {\n  --magic-box-background: var(--magic-highlight, #f3f1fc);\n  --magic-text: var(--magic-text-dark, #1d2939);\n}\n\n.subject[data-v-91e50390] {\n  font-size: 1rem;\n  color: var(--magic-text-dark, #1d2939);\n}\n\n.description[data-v-91e50390] {\n  font-size: 0.88rem;\n  color: var(--magic-text-medium, #5d6679);\n}", ""]);
// Exports
module.exports = exports;
